/* global axios */
import ApiClient from '../ApiClient';

class CopilotActionProposals extends ApiClient {
  constructor() {
    super('copilot/action_proposals', { accountScoped: true });
  }

  confirm(id) {
    return axios.post(`${this.url}/${id}/confirm`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new CopilotActionProposals();
